import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClipboardModule } from "ngx-clipboard";

// Dialog components
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { Ng2CompleterModule } from "../../components/common/ng2-completer/ng2-completer";
import { NgClickOutsideDirective } from "ng-click-outside2";
import { ConfirmationDialogService } from "../../services/confirmation-dialog";
import { graphqlProvider, graphqlProviderReplicatedData } from "../graphql.module";
import { LoadingState } from "../../services/loading-state";
import { Ng2SearchPipe } from "../../components/common/ng2-search-filter/ng2-filter.pipe";
import { PolicyService } from "../../services/policyservice";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    NavigationComponent,
    TranslateModule.forChild(),
    AngularSvgIconModule,
    FormsModule,
    RouterModule,
    Ng2CompleterModule,
    NgClickOutsideDirective,
    ClipboardModule,
    Ng2SearchPipe,
  ],
  providers: [ConfirmationDialogService, PolicyService, LoadingState, graphqlProvider, graphqlProviderReplicatedData],
  exports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    TranslateModule,
    AngularSvgIconModule,
    FormsModule,
    RouterModule,
    Ng2CompleterModule,
    ClipboardModule,
    NgClickOutsideDirective,
    Ng2SearchPipe,
  ],
})
export class NwdSharedModule {}
